import { createContext } from 'preact';
import { useEffect } from 'preact/hooks';
import { useSignal } from '@preact/signals';
import useConfig from '../config/config.context';
import CaasStorageKeys from '../constants/caas.storage.keys';

const ThemeContext = createContext({});

function ThemeProvider({ children }) {
  const { config } = useConfig();

  const theme = useSignal(config[CaasStorageKeys.CONFIG]?.theme || 'light');

  useEffect(() => {
    const html = document.querySelector('html');
    const topPadding = config[CaasStorageKeys.DEVICE]?.safeAreaInsetTop ?? 0;
    const bottomPadding =
      config[CaasStorageKeys.DEVICE]?.safeAreaInsetBottom ?? 0;
    const tabBarHeight = config[CaasStorageKeys.DEVICE]?.tabBarHeight ?? 0;

    if (theme) {
      html.setAttribute('class', theme.value);
    }

    document.documentElement.style.cssText = `--safe-space-top: ${topPadding}px; --safe-space-bottom: ${bottomPadding}px; --tab-bar-height: ${tabBarHeight}px;`;
  }, [theme.value]);

  return (
    <ThemeContext.Provider value={{ theme: theme.value }}>
      {children}
    </ThemeContext.Provider>
  );
}

export { ThemeContext, ThemeProvider };
